import React, { useEffect, useState, useRef } from "react";
import LessonPage from "./LessonPage";
import { FaPlay, FaVolumeMute, FaFolder, FaBook, FaArrowLeft, FaChevronRight } from "react-icons/fa";
import { config } from "../../config";
import axios from "axios";
import MembershipTimer from "./MembershipTimer";

const apiUrl = config.apiUrl;
const imageUrl = config.imageUrl;

const CoursesPage = () => {
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedModule, setSelectedModule] = useState(null);
  const [selectedLesson, setSelectedLesson] = useState(null);
  const [selectedLessonIndex, setSelectedLessonIndex] = useState(0);
 
  const [expandedModule, setExpandedModule] = useState(null);
  // const membershipTypes = JSON.parse(localStorage.getItem('membership_types')) || [];
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [membershipTypes, setMembershipTypes] = useState([]);
  const [membershipUser, setMembershipUser] = useState([])
  const [latestActive, setLatestActive] = useState('')
  const [loading, setLoading] = useState(true);

 useEffect(() => {
    const localMemberships = JSON.parse(localStorage.getItem('membership_types')) || [];
    setMembershipTypes(localMemberships);
  }, []);


useEffect(() => {
  const fetchData = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${apiUrl}/courses`);
      const responseUser = await axios.get(`${apiUrl}/user/membership`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Sort courses based on sort_order
      const sortedCourses = response.data.courses.sort((a, b) => {
        return (a.sort_order || 0) - (b.sort_order || 0);
      });


      setCourses(sortedCourses);
      setMembershipUser(responseUser.data.all_memberships);
      
      // Get current date for comparison
      const now = new Date();
      
      // Filter active memberships correctly
      const activeMemberships = responseUser.data.all_memberships.filter(m => {
        return m.end_date === null || new Date(m.end_date) > now;
      });

      const activeTypeIds = activeMemberships.map(m => m.membership_id);

      const filtered = sortedCourses.filter(course => {
        // Always show courses available to all
        if (course.membership_type === "all") return true;
        
        // Show courses for active memberships
        return activeTypeIds.includes(Number(course.membership_type));
      });
      
      setFilteredCourses(filtered);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  fetchData();
}, [apiUrl]);



//   useEffect(() => {
//   if (courses.length > 0 && membershipUser.length > 0 && latestActive) {
//     const activeMembershipIds = membershipUser
//       .filter(m => new Date(m.end_date) > new Date()) // future end date
//       .map(m => m.membership_type_id);

//     const filtered = courses.filter(course =>
//       activeMembershipIds.includes(Number(course.membership_type)) || course.membership_type === "all"
//     );

//     setFilteredCourses(filtered);
//   } else {
//     setFilteredCourses([]);
//   }
// }, [courses, membershipUser, latestActive]);


  const handleCourseClick = (course) => {
    const sortedCourse = {
      ...course,
      modules: course.modules
        .sort((a, b) => a.sort_order - b.sort_order)
        .map(module => ({
          ...module,
          lessons: module.lessons?.sort((a, b) => a.sort_order - b.sort_order) || []
        }))
    };
    setSelectedCourse(sortedCourse);
    setSelectedModule(null);
    setSelectedLesson(null);
    setExpandedModule(null);
  };

  const handleLessonClick = (module, lesson, lessonIndex) => {
    setSelectedModule(module);
    setSelectedLesson(lesson);
    setSelectedLessonIndex(lessonIndex);
  };

  const handleBackToModules = () => {
    setSelectedModule(null);
    setSelectedLesson(null);
  };

  const handleBackToCourses = () => {
    setSelectedCourse(null);
    setSelectedModule(null);
    setSelectedLesson(null);
    setExpandedModule(null);
  };

  const toggleModule = (moduleId) => {
    setExpandedModule(expandedModule === moduleId ? null : moduleId);
  };



  const findLessons = (moduleId) => {
    if (!selectedCourse) return [];
    const module = selectedCourse.modules.find(m => m.id === moduleId);
    return module ? module.lessons : [];
  };

  // if (loading) {
  //   return (
  //     <div className="flex justify-center items-center h-screen">
  //       <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
  //     </div>
  //   );
  // }

if (loading) {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}


  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-indigo-50 py-8 px-2 md:px-4 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl sm:text-5xl font-extrabold text-center mb-8 text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600">
          Explore Our Courses
        </h1>

         {membershipUser.filter(m => 
            m.membership?.end_date === null || 
            (m.end_date && new Date(m.end_date) > new Date())
          ).map(membership => (
            <MembershipTimer 
              key={membership.id}
              endDate={membership.end_date} 
              membershipName={membership?.membership?.membership_type}
            />
          ))}

          {membershipUser.filter(m => 
            m.membership?.end_date === null || 
            (m.end_date && new Date(m.end_date) > new Date())
          ).length === 0 && (
            <p className="text-red-500 font-bold"></p>
          )}
                  

        {selectedCourse && !selectedModule && (
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="p-6 sm:p-8">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl sm:text-3xl font-bold text-gray-800">
                  {selectedCourse.name}
                </h2>
                <button
                  onClick={handleBackToCourses}
                  className="flex items-center px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-all duration-200"
                >
                  <FaArrowLeft className="mr-2" />
                  Back
                </button>
              </div>
              
              <p className="text-gray-600 mb-8">{selectedCourse.desc}</p>
              
              <div className="space-y-4">
                {selectedCourse.modules.map((module) => (
                  <div key={module.id} className="border border-gray-200 rounded-xl overflow-hidden">
                    <button
                      onClick={() => toggleModule(module.id)}
                      className="w-full flex justify-between items-center p-4 bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
                    >
                      <div className="flex items-center">
                        <FaFolder className="mr-3 text-indigo-500" />
                        <span className="font-medium text-gray-800">{module.moduleTitle}</span>
                      </div>
                      <FaChevronRight 
                        className={`transition-transform duration-200 ${expandedModule === module.id ? 'transform rotate-90' : ''}`} 
                      />
                    </button>
                    
                    {expandedModule === module.id && (
                      <ul className="divide-y divide-gray-200">
                        {module.lessons.map((lesson, lessonIndex) => (
                          <li key={lessonIndex}>
                            <button
                              onClick={() => handleLessonClick(module, lesson, lessonIndex)}
                              className="w-full flex items-center p-4 hover:bg-indigo-50 transition-colors duration-150 text-left"
                            >
                              <FaBook className="mr-3 text-indigo-400" />
                              <span className="text-gray-700">{lesson.title}</span>
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {selectedCourse && selectedModule && selectedLesson && (
          <LessonPage
            course={selectedCourse}
            module={selectedModule}
            lesson={selectedLesson}
            lessonIndex={selectedLessonIndex}
            onBack={handleBackToModules}
          />
        )}

        {!selectedCourse && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredCourses && filteredCourses.map((course) => (
              <div
                key={course.id}
                className="bg-white rounded-xl shadow-md overflow-hidden transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={`${imageUrl}/${course.image}`}
                    alt={course.name}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                </div>
                <div className="p-5">
                  <h2 className="text-xl font-bold mb-2 text-gray-800 line-clamp-2">
                    {course.name}
                  </h2>
                  <p className="text-gray-600 text-sm mb-4 line-clamp-3">{course.desc}</p>
                  <button
                    onClick={() => handleCourseClick(course)}
                    className="w-full px-4 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg hover:from-indigo-700 hover:to-purple-700 transition-all duration-300 shadow-md hover:shadow-lg"
                  >
                    Explore Course
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CoursesPage;